import { MotionValue } from '../../value/index.mjs';
import { px } from '../../value/types/numbers/units.mjs';
import { addAttrValue } from '../attr/index.mjs';
import { addStyleValue } from '../style/index.mjs';
import { createSelectorEffect } from '../utils/create-dom-effect.mjs';
import { createEffect } from '../utils/create-effect.mjs';
import { frame } from '../../frameloop/frame.mjs';
var toPx = px.transform;

function addSVGPathValue(element, state, key, value) {
  frame.render(function () {
    return element.setAttribute("pathLength", "1");
  });

  if (key === "pathOffset") {
    return state.set(key, value, function () {
      return element.setAttribute("stroke-dashoffset", toPx(-state.latest[key]));
    });
  } else {
    if (!state.get("stroke-dasharray")) {
      state.set("stroke-dasharray", new MotionValue("1 1"), function () {
        var _state$latest = state.latest,
            _state$latest$pathLen = _state$latest.pathLength,
            pathLength = _state$latest$pathLen === void 0 ? 1 : _state$latest$pathLen,
            pathSpacing = _state$latest.pathSpacing;
        element.setAttribute("stroke-dasharray", "".concat(toPx(pathLength), " ").concat(toPx(pathSpacing !== null && pathSpacing !== void 0 ? pathSpacing : 1 - Number(pathLength))));
      });
    }

    return state.set(key, value, undefined, state.get("stroke-dasharray"));
  }
}

var addSVGValue = function addSVGValue(element, state, key, value) {
  if (key.startsWith("path")) {
    return addSVGPathValue(element, state, key, value);
  } else if (key.startsWith("attr")) {
    return addAttrValue(element, state, convertAttrKey(key), value);
  }

  var handler = key in element.style ? addStyleValue : addAttrValue;
  return handler(element, state, key, value);
};

var svgEffect = /*@__PURE__*/createSelectorEffect( /*@__PURE__*/createEffect(addSVGValue));

function convertAttrKey(key) {
  return key.replace(/^attr([A-Z])/, function (_, firstChar) {
    return firstChar.toLowerCase();
  });
}

export { svgEffect };